function buildCatiLogoutUrl(url, participantKeycloakRealm, pmtUser, currentCatiSessionId) {
  return `${url}/realms/${participantKeycloakRealm}/vibrent-users/logOutCATISession?impersonatorEmail=${pmtUser}&catiSessionId=${currentCatiSessionId}`;
}

function readImpersonatedParticipant() {
  const impersonated = window.localStorage.getItem('ImpersonatedParticipant');
  if (!impersonated) {
    return null;
  }
  return JSON.parse(impersonated);
}

/**
 * Ends an active CATI session using Keycloak when configured, otherwise the CATI process API.
 * Reads session / impersonation identifiers from localStorage.
 */
export default function dispatchEndCatiSession({
  userDetail,
  currentActiveProgram,
  endCATIActiveSessions,
  endCATIProcess,
  type,
}) {
  const currentCatiSessionId = window.localStorage.getItem('CurrentActiveSessionId');
  const participantKeycloakRealm = window.localStorage.getItem('participantKeycloakRealm');
  const impersonated = readImpersonatedParticipant();

  if (!userDetail || !currentCatiSessionId || !impersonated) {
    return Promise.resolve();
  }

  const programCode = currentActiveProgram && currentActiveProgram.programCode;
  const endCatiKeycloak = programCode && userDetail.keycloakUrl && participantKeycloakRealm;

  if (endCatiKeycloak) {
    const endCatiURL = buildCatiLogoutUrl(
      userDetail.keycloakUrl,
      participantKeycloakRealm,
      userDetail.username,
      currentCatiSessionId,
    );
    return endCATIActiveSessions(
      endCatiURL,
      userDetail.jwtToken,
      programCode,
      currentCatiSessionId,
      impersonated.platformParticipantId,
      type,
      impersonated.id,
    );
  }

  return endCATIProcess(
    currentCatiSessionId,
    impersonated.platformParticipantId,
    type,
    impersonated.id,
  );
}
